import {
    Box,
    Typography,
    ToggleButton,
    ToggleButtonGroup,
    Stack,
    Tooltip,
    Divider,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import ResetViewButton from './ResetViewButton';
import { Info } from '@mui/icons-material';
import { useRecoilState } from 'recoil';
import { zoomToCursorState } from '~/state/atoms/toolsAtoms';
import { environmentState } from '~/state/atoms/engineAtoms';
import { useEffect } from 'react';

export default function PanToolOptions() {
    const [environment] = useRecoilState(environmentState);
    const [zoomToCursor, setZoomToCursor] = useRecoilState(zoomToCursorState);

    useEffect(() => {
        if (environment) {
            environment.panZoom.setZoomToCursor(zoomToCursor);
        }
    }, [environment, zoomToCursor]);

    const handleZoomToCursorToggle = (
        _: React.MouseEvent<HTMLElement, MouseEvent>,
        newZoomToCursor: boolean | null
    ) => {
        if (newZoomToCursor !== null) {
            setZoomToCursor(newZoomToCursor);
        }
    };

    return (
        <Box sx={{ m: 2 }}>
            <Box display={'flex'} alignItems={'center'}>
                <Typography variant="h6">
                    <FormattedMessage id="pan" />
                </Typography>
                <Divider
                    flexItem
                    orientation="vertical"
                    sx={{ mx: 1, my: 1 }}
                />
                <ResetViewButton />
            </Box>
            <Box display="grid" rowGap={1} my={1}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="subtitle1" mr={0.75}>
                        <FormattedMessage id="zoomToCursor" />
                    </Typography>
                    <Tooltip
                        title={<FormattedMessage id="zoomToCursorGuide" />}
                        placement="right"
                    >
                        <Info fontSize="small" />
                    </Tooltip>
                </Stack>
                <ToggleButtonGroup
                    color="primary"
                    value={zoomToCursor}
                    exclusive
                    onChange={handleZoomToCursorToggle}
                    aria-label="Zoom to cursor"
                    fullWidth
                    size="small"
                >
                    <ToggleButton value={true}>On</ToggleButton>
                    <ToggleButton value={false}>Off</ToggleButton>
                </ToggleButtonGroup>
            </Box>
        </Box>
    );
}
